import React, { forwardRef } from 'react'

import { RichTextEditorCore } from './components/editor/index'
import { Toolbar } from './components/toolbar/index'
import type { RteHandle, RteProps } from './types'

/**
 * The editor with the Radix toolbar wired in. This is the web entry point and
 * what the barrel exports; native imports `./native` instead, which leaves the
 * toolbar — and with it Radix — out of the bundle entirely.
 */
export const RichTextEditor = forwardRef<RteHandle, RteProps>(
  function RichTextEditor(props, ref) {
    return (
      <RichTextEditorCore
        {...props}
        ref={ref}
        renderToolbar={ctx => <Toolbar {...ctx} />}
      />
    )
  },
)
